import { render, staticRenderFns } from "./NeighbourhoodStory.vue?vue&type=template&id=768ebb50&scoped=true&"
import script from "./NeighbourhoodStory.vue?vue&type=script&lang=js&"
export * from "./NeighbourhoodStory.vue?vue&type=script&lang=js&"
import style0 from "./NeighbourhoodStory.vue?vue&type=style&index=0&id=768ebb50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768ebb50",
  null
  
)

export default component.exports